// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"a04a2bee","808":"d7b1d067"}[chunkId] + ".chunk.css";
};